import ddt from '@wix/da-ddt';
import { type Action, handleActions } from 'redux-actions';
import { actionTypePrefix, reduxKey } from './constants';
import {
  resetEditorPublishResults,
  publishComment,
  publishCommentFailure,
  publishCommentSuccess,
  focusEditor,
  focusDone,
} from './actionCreators';
import { CommentBoxStoreSlice } from './types';

const actionHandlers = handleActions<CommentBoxStoreSlice, any>(
  {
    [publishComment.toString()]: state => ({
      ...state,
      isBusy: true,
      publishResult: null,
      isError: false,
      errorMsg: null,
    }),
    [publishCommentSuccess.toString()]: (
      state,
      action: ReturnType<typeof publishCommentSuccess>
    ) => ({
      ...state,
      isBusy: false,
      publishResult: action.payload,
      isError: false,
      errorMsg: null,
    }),
    [publishCommentFailure.toString()]: (
      state,
      action: ReturnType<typeof publishCommentFailure>
    ) => {
      ddt.log('comments', 'Failed to post comment', action);
      const { shouldResetEditor, errorMsg } = action.payload;

      return {
        ...state,
        isBusy: false,
        publishResult: null,
        isError: true,
        shouldResetEditor,
        errorMsg,
      };
    },
    [resetEditorPublishResults.toString()]: state => ({
      ...state,
      isBusy: false,
      shouldResetEditor: false,
      publishResult: null,
      isError: false,
      errorMsg: null,
    }),
    [focusEditor.toString()]: state => ({
      ...state,
      isFocusRequested: true,
    }),
    [focusDone.toString()]: state => ({
      ...state,
      isFocusRequested: false,
    }),
  },
  {
    isBusy: false,
    publishResult: null,
    isError: false,
    errorMsg: null,
    isFocusRequested: false,
  }
);

const reducers = {
  [reduxKey as string]: (state = {}, action: Action<any>) => {
    // Server errors if we don't check for an undefined action here.
    if (
      !action ||
      !action.payload ||
      !action.type ||
      !action.type.startsWith(`${actionTypePrefix}/`)
    ) {
      return state;
    }
    const { editorId } = action.payload;

    if (!editorId) {
      return state;
    }

    const innerState = state[editorId];
    const newInnerState = actionHandlers(innerState, action);
    return {
      ...state,
      [editorId]: newInnerState,
    };
  },
};

export default reducers;
